// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3f9d0726","455":"6e099508"}[chunkId] + ".chunk.js";
};